import { MenuItem, Select } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * @Description This function lets you return Updates.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Port() {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.UPDATES.';
    const [auto, setAuto] = useState(false);

    const handleChange = (e) => {
        setAuto(e.target.checked);
    }

    return (
        <div className="sgeneral">
            <div>{t(label + 'UPDATE')}</div>
            <div className="port-label">{t(label + 'AUTO')}&nbsp;&nbsp;&nbsp;
                <label className="switch small">
                    <input type="checkbox" onChange={handleChange} checked={auto}/>
                    <span className="slider round red"></span>
                </label>
            </div>
            <div className="sgeneral-divider"></div>
            <div className="updates-label">{t(label + 'SCHEDULE')}</div>
            <Select className="updates-select" variant="outlined" defaultValue="regularly" disabled={!auto}>
                <MenuItem value="regularly"><span className="sgeneral-day">{t(label + 'REGULARLY')}</span><span className="updates-label">({t(label + 'DEFAULT')})</span></MenuItem>
            </Select>
            <div className="updates-label-sec">{t(label + 'AUTO-UPDATES')}</div>
            <div className="sgeneral-divider"></div>
            <div className="update-buttons">
                <div>
                    <button className="sgeneral-save">{t(label + 'SAVE')}</button><button className="cancel-button">{t(label + 'CANCEL')}</button>
                </div>
                <div>
                    <button className="history-button">{t(label + 'HISTORY')}</button><button className="sgeneral-save">{t(label + 'NOW')}</button>
                </div>
            </div>
        </div>
    );
}
export default Port;